import React from 'react';
import { CardGroup, CTABlock, Paper, PressCard } from 'library';
import { take } from 'lodash';
import { formatDate } from 'utils/formatters';

import LoadMore from '../../common/Pagination/LoadMore';
import usePagination from '../../common/Pagination/UsePagination';
import Layout from '../../layout';
import PressReleaseList from '../PressReleaseList/PressReleaseList';

import './NewsroomPage.scss';

const NewsroomPage = ({ data }) => {
  const { newsroom, pressRelease } = data;
  const newsroomPressStories = newsroom.nodes;
  const pressReleases = pressRelease.nodes;
  const { hasMoreToLoad, countVisible, handleLoadMore } = usePagination({
    total: newsroomPressStories?.length,
    initialPageCount: 6,
    incrementLimit: 6,
  });

  return (
    <Layout>
      <div className="NewsroomPageCTAWrapper">
        <CTABlock
          title="Newsroom"
          text="View our latest press releases and media coverage below. Have a media inquiry? We’d love to chat!"
          buttonLabel="Contact Us"
          buttonLink="/contact-us/"
          buttonTheme="outlined"
        />
      </div>
      <Paper divider theme="medium" pad={{ top: 0.6, bottom: 6 }}>
        <CardGroup cardSize={PressCard.size} title="Hometap in the Media">
          {take(newsroomPressStories, countVisible).map((story, index) => {
            return (
              <PressCard
                title={story.title}
                source={story.newsroomPressStories.pressSource}
                date={formatDate(story.date)}
                logo={story.newsroomPressStories.pressLogo?.sourceUrl}
                link={story.newsroomPressStories.destinationLink}
                key={index}
              />
            );
          })}
        </CardGroup>
        {hasMoreToLoad && <LoadMore onClick={handleLoadMore} />}
      </Paper>
      <PressReleaseList pressReleases={pressReleases} />
    </Layout>
  );
};

export default NewsroomPage;
